import { Messages } from '~src/codegen/Localize';

import { PlanContentType } from './planContentsService';

/**
 * The localized name of a plan item's content type, as shown in the contents grid and the Run dialog. The
 * supported types grow over time, so a type without a label here shows none rather than a wrong one.
 */
export function typeLabel(contentType: PlanContentType): string {
  switch (contentType) {
    case 'workbook': return Messages.workbook();
    case 'datasource': return Messages.datasource();
    case 'project': return Messages.project();
    default: return '';
  }
}
